import { useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { useGlobalModalsContext } from 'contexts/globalModalsContext';
import Button from 'ui/Button';
import Icon from 'ui/Icon';
import Menu from 'ui/Menu';

import { useOfficeContext } from '../../utils/addin/office';
import { useCurrentUser } from '../../utils/user';
import ManageSubscriptionModal from '../ActionMenu/ManageSubscriptionModal';
import ExcelCellsSourceModal from '../ExcelCellsSourceModal';
import NewDiagramFromTemplateModal from '../NewDiagramFromTemplateModal';
import SankeyExcelBindingProvider from '../SankeyExcelBindingProvider';

const NewDiagramButton: React.FC = () => {
  const { user } = useCurrentUser();
  const { isExcel } = useOfficeContext();
  const { openConversionModal } = useGlobalModalsContext();

  const subscribeModalDisclosure = useDisclosure();
  const templateModalDisclosure = useDisclosure();
  const excelModalDisclosure = useDisclosure();

  if (!user?.can_create_sankeys) {
    if (!user?.has_active_subscription) {
      return (
        <Button
          onClick={() => openConversionModal('Creating')}
          variant="primary-solid"
          size="sm"
        >
          Create new <Icon icon="crown" />
        </Button>
      );
    } else {
      return (
        <>
          <Button
            onClick={subscribeModalDisclosure.onOpen}
            variant="primary-solid"
            size="sm"
          >
            Create new <Icon icon="crown" />
          </Button>
          <ManageSubscriptionModal
            {...subscribeModalDisclosure}
            message="To create a new diagram please upgrade your subscription or delete some of your existing diagrams to free up more diagram slots."
            buttonText="Manage subscription"
          />
        </>
      );
    }
  }

  if (!isExcel) {
    return (
      <>
        <Button
          onClick={templateModalDisclosure.onOpen}
          variant="primary-solid"
          size="sm"
        >
          <Icon icon="plus" /> Create new
        </Button>
        <NewDiagramFromTemplateModal {...templateModalDisclosure} />
      </>
    );
  }

  return (
    <>
      <Menu.Root>
        <Menu.Trigger>
          <Button variant="primary-solid" size="sm">
            <Icon icon="plus" /> Create new
          </Button>
        </Menu.Trigger>
        <Menu.Content>
          <Menu.Item value="from-excel" onClick={excelModalDisclosure.onOpen}>
            Create from my Excel data
          </Menu.Item>
          <Menu.Item
            value="from-template"
            onClick={templateModalDisclosure.onOpen}
          >
            Create from template
          </Menu.Item>
        </Menu.Content>
      </Menu.Root>
      <SankeyExcelBindingProvider>
        <ExcelCellsSourceModal isCreating {...excelModalDisclosure} />
      </SankeyExcelBindingProvider>
      <NewDiagramFromTemplateModal {...templateModalDisclosure} />
    </>
  );
};

export default NewDiagramButton;
